import { IMDSButtonProps, MDSButton, MDSButtonVariant } from "@/mds/components/buttons";
import styled from "@emotion/styled";

interface SidebarButtonProps extends IMDSButtonProps {}

export const SidebarButton = ({ children, ...props }: SidebarButtonProps) => {
  return (
    <StyledButton {...props} variant={MDSButtonVariant.Chrome}>
      {children}
    </StyledButton>
  );
};

const StyledButton = styled(MDSButton)`
  justify-content: flex-start;
  box-shadow: none;
`;
